import type { FC } from 'react';

import type { IllustrationProps } from './types';

export const CoffeeAndBookIllustration: FC<IllustrationProps> = ({
  height = 128,
  width = 128,
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 128 128"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M100.197 33.2764H98.9875V24H47V49.9938C47 64.3497 58.6378 75.9875 72.9937 75.9875C84.9293 75.9875 94.9792 67.9399 98.0309 56.977H100.197C106.731 56.977 112.047 51.6611 112.047 45.1269C112.047 38.5928 106.731 33.2764 100.197 33.2764ZM100.197 51.4253H98.9465C98.9724 50.9512 98.9876 50.4743 98.9876 49.9938V38.8281H100.197C103.67 38.8281 106.496 41.6538 106.496 45.127C106.496 48.6001 103.67 51.4253 100.197 51.4253Z"
      fill="#EE399E"
    />
    <path
      d="M89.6752 36.0527H73.3574V52.3706H89.6752V36.0527Z"
      fill="#FDD651"
    />
    <path
      d="M33.8013 82.4893C29.5155 82.4893 25.7766 84.8491 23.797 88.3328H107.946V91.3328H22.6189C22.4152 92.1885 22.2959 93.0764 22.2959 93.9936C22.2959 94.9106 22.4152 95.7985 22.6189 96.6541H107.946V99.6541H23.7969C25.7765 103.138 29.5154 105.498 33.8013 105.498H108V82.4893H33.8013Z"
      fill="#DCE5F2"
    />
    <path
      d="M107.947 91.333V88.333H23.7972C23.27 89.2607 22.8727 90.2684 22.6191 91.333H107.947Z"
      fill="#B6C7E0"
    />
    <path
      d="M107.947 99.6543V96.6543H22.6191C22.8727 97.7189 23.27 98.7266 23.7971 99.6543H107.947Z"
      fill="#B6C7E0"
    />
    <path
      d="M23.7969 99.6541C23.2698 98.7264 22.8724 97.7187 22.6189 96.6541C22.4152 95.7985 22.2959 94.9106 22.2959 93.9936C22.2959 93.0764 22.4152 92.1885 22.6189 91.3328C22.8724 90.2682 23.2698 89.2606 23.797 88.3328C25.7766 84.8491 29.5155 82.4893 33.8013 82.4893H112V75.9873H33.8013C23.8716 75.9873 15.7939 84.065 15.7939 93.9936C15.7939 103.922 23.8716 112 33.8013 112H112V105.498H33.8013C29.5154 105.498 25.7765 103.138 23.7969 99.6541Z"
      fill="#0D3880"
    />
    <path d="M82.6133 24.041H80.334V40.7788H82.6133V24.041Z" fill="#F8B1DC" />
  </svg>
);
